<template>
    <div class="project-card">
        <img :src="fullImageUrl(image)" alt="项目图片" class="project-image" />
        <div class="project-info">
            <h3>{{ title }}</h3>
            <router-link :to="`/project/${id}`" class="detail-btn">查看详情</router-link>
        </div>
    </div>
</template>

<script>
import { fullImageUrl } from '../utils/request';

export default {
    name: 'ProjectCard',
    props: {
        image: String,
        title: String,
        id: String
    },
    methods: {
        fullImageUrl
    }
};
</script>

<style scoped>
.project-card {
    border: 1px solid #eee;
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    width: 100%;
    margin: 0;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
    transition: transform 0.2s, box-shadow 0.2s;
    height: 340px !important;
    display: flex !important;
    flex-direction: column !important;
    min-width: 0;
    position: relative !important;
}

.project-card:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 6px 32px rgba(30, 60, 120, 0.12);
}

.project-image {
    width: 100% !important;
    height: 210px !important;
    object-fit: cover !important;
    flex-shrink: 0 !important;
    min-height: 210px !important;
    max-height: 210px !important;
    display: block !important;
}

.project-info {
    padding: 22px 20px 20px 20px;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    align-items: flex-start;
    flex-grow: 1 !important;
    min-height: 130px !important;
    max-height: 130px !important;
    box-sizing: border-box !important;
    position: relative !important;
}

.project-info h3 {
    font-size: 1.18rem;
    font-weight: 600;
    margin: 0 0 60px 0 !important;
    color: #1a2a47;
    line-height: 1.3;
    /* 限制标题最多显示2行，超出显示省略号 */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    flex-shrink: 0;
    position: relative !important;
    z-index: 1 !important;
}

.detail-btn {
    display: inline-block !important;
    background: rgba(255, 255, 255, 0.85);
    color: #222;
    border-radius: 28px;
    padding: 8px 32px;
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    border: 2px solid #222;
    box-shadow: 0 2px 12px rgba(30, 60, 120, 0.06);
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    letter-spacing: 1px;
    position: absolute !important;
    bottom: 20px !important;
    left: 20px !important;
    z-index: 10 !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
}

.detail-btn:hover {
    background: #222;
    color: #fff;
    box-shadow: 0 4px 18px rgba(30, 60, 120, 0.13);
}

@media (max-width: 768px) {
    .project-card {
        height: 300px !important;
    }

    .project-image {
        height: 180px !important;
        min-height: 180px !important;
        max-height: 180px !important;
        flex-shrink: 0 !important;
    }

    .project-info {
        padding: 16px 16px 16px 16px;
        min-height: 120px !important;
        max-height: 120px !important;
    }

    .project-info h3 {
        font-size: 1.08rem;
        margin-bottom: 50px !important;
        -webkit-line-clamp: 2;
    }

    .detail-btn {
        font-size: 0.9rem;
        padding: 6px 16px;
        border-radius: 16px;
        bottom: 16px !important;
        left: 16px !important;
    }
}

@media (max-width: 480px) {
    .project-card {
        height: 280px !important;
    }

    .project-image {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
        flex-shrink: 0 !important;
    }

    .project-info {
        min-height: 120px !important;
        max-height: 120px !important;
    }

    .project-info h3 {
        font-size: 1rem;
        margin-bottom: 50px !important;
        -webkit-line-clamp: 2;
    }

    .detail-btn {
        font-size: 0.85rem;
        padding: 5px 14px;
        bottom: 16px !important;
        left: 16px !important;
    }
}
</style>